import { render } from "./MappingRule.vue?vue&type=template&id=e1123b90&scoped=true"
import script from "./MappingRule.vue?vue&type=script&lang=js"
export * from "./MappingRule.vue?vue&type=script&lang=js"

import "./MappingRule.vue?vue&type=style&index=0&id=e1123b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1123b90"]])

export default __exports__